/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientManualMerge {
  angular.module("meevo.plugins.clientManualMerge", []);
}